export default (theme) => ({
  container: {
    padding: 16,
  },
  strikethrough: {
    textDecoration: "line-through",
  },
  line: {
    paddingBottom: 20,
  },
  next: {
    marginTop: 20,
  },
});
